import {
	API_GET_ALL_CONTACT_COMMENT,
	API_GET_ALL_CONTACT_COMMENT_SUCCESS,
	API_GET_ALL_CONTACT_COMMENT_FAIL,
} from '../actions/contactComment';
import { createReducer } from '@reduxjs/toolkit';
import { errorHandler, ErrorAction } from 'utils/error';

const initialState = {
	loading: false,
	list: [],
};

const contactComments = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_CONTACT_COMMENT]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_CONTACT_COMMENT_FAIL]: (state, action) => {
		errorHandler('Commentaire contact', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_CONTACT_COMMENT_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default contactComments;
